import React, {
  memo,
  useContext, useEffect, useState,
} from 'react';
import {
  Alert, AlertTitle, Box, Grid,
} from '@mui/material';
import api from '../../../api/req';
import { AppContext } from '../../../providers/authProvider';
import { EditorControls } from '../../BaseEditor';
import { EditorContainer } from '../../../components/Styled/Forms';
import Budgets from '../exchange/editor/budgets';
import Warnings from './warnings';
import Loader from '../../../components/MaterialUI/loader';

function Editor() {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [org, setOrg] = useState({ id: null });
  const [budgets, setBudgets] = useState([]);
  const [date, setDate] = useState(new Date().toISOString()
    .slice(0, 10));
  const { auth, currentUser } = useContext(AppContext);

  useEffect(
    () => setOrg(currentUser.org),
    [currentUser.org],
  );
  useEffect(
    () => {
      const loader = async () => {
        const r = await api.get('/api/catalog/budgets/', auth, { org: org.id });
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      if (org && org.id) {
        setLoading(true);
        setErr(null);
        loader()
          .then((d) => setBudgets(d.map((b) => ({
            checked: true,
            id: b.id,
            repr: b.repr,
          }))))
          .catch((e) => setErr(e.message))
          .finally(() => setLoading(false));
      }
    },
    [auth, org],
  );

  return (
    <Box sx={{ overflow: 'auto', height: '100%' }}>
      {loading && (
        <Loader text="Завантаження" />
      )}
      {err && (
      <Alert severity="error" onClose={() => setErr(null)}>
        <AlertTitle>
          {err}
        </AlertTitle>
      </Alert>
      )}
      <EditorContainer style={{
        overflow: 'inherit',
        height: 'auto',
      }}
      >
        <Grid container>
          <Grid item sm={2}>
            <EditorControls.DateInput
              value={date}
              onChange={(e, v) => setDate(v)}
              label="Дата"
            />
          </Grid>
          {currentUser.is_superuser
            ? (
              <Grid item sm={4}>
                <EditorControls.ItemPicker
                  label="Установа"
                  backend="/api/catalog/orgs/"
                  canErase
                  value={org}
                  onChange={(e, v) => setOrg(v)}
                />
              </Grid>
            )
            : (
              <EditorControls.StringInput
                label="Установа"
                value={currentUser.org.repr}
              />
            )}

          <Grid item sm={currentUser.is_superuser ? 6 : 10} sx={{ display: 'flex', alignItems: 'center', px: 3 }}>
            <Budgets
              budgets={budgets}
              onChange={(e, v) => setBudgets(v)}
            />
          </Grid>

        </Grid>
        <Warnings
          currentOrg={org}
          budgets={budgets}
          currentDate={date}
        />
      </EditorContainer>

    </Box>
  );
}

export default memo(Editor);
